const MS_PER_DAY = 86_400_000;

/**
 * Whole calendar days from today to a date-only value (a due date), negative when it is in the past.
 * Null for a missing or unparseable date, never 0.
 *
 * Date-only values are stored as UTC midnight, so the due day is read from its UTC parts: local parts would
 * move it back a day in zones west of UTC, where UTC midnight is still the previous evening (e.g. Los Angeles).
 * Today is the local calendar day of `now`. Both sides are UTC midnights, so the difference is an exact whole
 * number of days.
 */
export function calendarDaysUntil(dueDate: string | null, now: Date): number | null {
  if (!dueDate) return null;
  const dueMs = Date.parse(dueDate);
  if (Number.isNaN(dueMs)) return null;
  const due = new Date(dueMs);
  const dueDay = Date.UTC(due.getUTCFullYear(), due.getUTCMonth(), due.getUTCDate());
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return (dueDay - today) / MS_PER_DAY;
}

/**
 * The viewer's local calendar day as `YYYY-MM-DD`. Built from local parts, never `toISOString()`,
 * which would give the UTC day (a day behind in Australia in the morning).
 */
export function toLocalDateParam(now: Date): string {
  const year = String(now.getFullYear()).padStart(4, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
